import RegionModel from 'Models/RegionModel';

const WowClassicHardcoreModel = {};

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW_CLASSIC_HARDCORE -> RegionMap::REGION_ID_EU
WowClassicHardcoreModel[RegionModel.EU.id] = [
  {
    id: 1,
    title: 'Nek’Rosh',
  },
  {
    id: 2,
    title: 'Stitches',
  },
];

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW_CLASSIC_HARDCORE -> RegionMap::REGION_ID_USA
WowClassicHardcoreModel[RegionModel.USA.id] = [
  {
    id: 1,
    title: 'Defias Pillager',
  },
  {
    id: 2,
    title: 'Skull Rock',
  },
];

// eslint-disable-next-line import/prefer-default-export
export { WowClassicHardcoreModel };
